
import http from '../HttpService'

const dataType = `documents`
const baseService = http(dataType)
const additionalRequest = {}

export default Object.assign(baseService, additionalRequest)
